export default {

	install: function install (Vue) {

		Vue.loadStaticData = function loadStaticData(fromKey) {
			return new Promise((resolve, reject) => {
				if (window[fromKey]) {
					const data = Object.freeze(Object.assign({}, window[fromKey]));
					resolve(data);
				} else {
					reject(Error(`Missing window.${fromKey}`));
				}
			});
		};

	}

};
